// extracted by mini-css-extract-plugin
module.exports = {"container":"e_tq","link":"e_uq","imageContainer":"e_vq","author":"e_wq","text":"e_xq","buttonIcon":"e_yq"};